import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalTemplateClone, templateClone } from '../../../redux/main/main.actions';
import { selectIsModalTemplateCloneEnabled, selectModalTemplateCloneData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalTemplateClone.scss';

function buildName(title = '') {
    return (`${title}`);
}

export const ModalTemplateClone = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalTemplateCloneEnabled);
    const modalData = useSelector(selectModalTemplateCloneData);

    const inputRef = useRef(null);
    const [value, setValue] = useState(buildName(modalData?.template?.title) || '');

    useEffect(() => {
        if (!modalData?.template?.title) return;

        if (value !== buildName(modalData?.template?.title)) {
            setValue(buildName(modalData?.template?.title));
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
            trackEvent('app_modal_template_clone_submit', {
                page: 'app',
                type: 'modals',
            });
        dispatch(templateClone(modalData?.template?.id, value));
        dispatch(toggleModalTemplateClone(null));

        setTimeout(() => {
            setValue(buildName(modalData?.template?.title));
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalTemplateClone(null));
        setTimeout(() => {
            setValue(buildName(modalData?.template?.title));
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
    };

    const handleRender = () => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-template-clone`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`Create a diagram from template`}</div>
            <div className="modal-content-body">

                <div className="description-text">Enter a new diagram name</div>

                <input
                    maxLength="1000"
                    ref={inputRef}
                    autoComplete="off"
                    spellCheck="false"
                    type="text"
                    id="template-name"
                    placeholder="Enter a new diagram name"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />

                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>Cancel</button>
                    <button onClick={() => handleSave()}>Create diagram</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalTemplateClone;
